import React, { useRef, useState, useEffect } from "react";
import "./Grid.scss";

interface IGridProps {
    leftHeader: any,
    leftContent: any,
    rightHeader: any,
    rightContent: any
}

const Grid = (props: IGridProps) => {
    const { leftHeader, leftContent, rightHeader, rightContent } = props;

    const leftHeaderRef = useRef<HTMLDivElement>(null);
    const rightHeaderRef = useRef<HTMLDivElement>(null);
    const [leftHeaderHeight, setLeftHeaderHeight] = useState(0);
    const [rightHeaderHeight, setRightHeaderHeight] = useState(0);

    const borderWidth = 1;

    useEffect(() => {
        if (leftHeaderRef.current) {
            setLeftHeaderHeight(leftHeaderRef.current.offsetHeight);
        }
        if (rightHeaderRef.current) {
            setRightHeaderHeight(rightHeaderRef.current.offsetHeight);
        }
    }, []);

    return (
        <div className="grid">
            <div className="left">
                <div ref={leftHeaderRef} className="gridHeader" style={{borderWidth: `${borderWidth}px`}}>{leftHeader}</div>
                <div className="gridContent" style={{ height: `calc(100% - ${leftHeaderHeight}px)` }}>{leftContent}</div>
            </div>
            <div className="right">
                <div ref={rightHeaderRef} className="gridHeader" style={{borderWidth: `${borderWidth}px`}}>{rightHeader}</div>
                <div className="gridContent" style={{ height: `calc(100% - ${rightHeaderHeight}px)` }}>{rightContent}</div>
            </div>
        </div>
    );
}

export default Grid;
